export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getAccountContacts: (accountNumber, roles, fromPage, pageSize) => {
            return JsonRPCService.send('pc', 'gateway/contact', 'getMainAccountContacts', [
                accountNumber,
                roles || [],
                fromPage || 0,
                pageSize || 10
            ]);
        },
        getRelatedAccountContacts: (accountNumber, relationships, fromPage, pageSize) => {
            return JsonRPCService.send('pc', 'gateway/contact', 'getRelatedAccountContacts', [
                accountNumber,
                fromPage || 0,
                pageSize || 10,
                relationships || []
            ]);
        },
        getCommonAccountContacts: (accountNumber, fromPage, pageSize) => {
            return JsonRPCService.send('pc', 'gateway/contact', 'getCommonAccountContacts', [
                accountNumber,
                fromPage || 0,
                pageSize || 10
            ]);
        },
        getAccountContactDetails: contactId => {
            return JsonRPCService.send('pc', 'gateway/contact', 'getAccountContactDetails', [contactId]);
        },
        getPolicyContactSummaries: (policyNumber, roles, fromPage, pageSize) => {
            return JsonRPCService.send('pc', 'gateway/contact', 'getPolicyContactSummaries', [
                policyNumber,
                roles || [],
                fromPage || 0,
                pageSize || 10
            ]);
        },
        getPolicyContactDetails: (contactId, policyNumber) => {
            return JsonRPCService
                .send(
                    'pc',
                    'gateway/contact',
                    'getPolicyContactDetails',
                    [contactId, policyNumber]
                );
        }
    };
}];